$( document ).ready(function() {